import type { UploadOptions } from '@rpldy/uploady'

import type { TokenRefreshManager } from '../../../utils/tokenRefreshManager'

export interface ParseImagePluginParams {
    appId: string
    uploadOptions?: UploadOptions
    tokenRefreshManager?: TokenRefreshManager
    /** 最大上传大小（字节） */
    maxSize?: number
}

export interface UploadingItem {
    id: string
    file: string | File
    fallbackPos?: number
    batchId?: string
    batchIndex?: number
    insertStrategy?: 'batch-anchor' | 'placeholder'
}

export type PlaceholderMeta =
    | { type: 'add'; id: string; pos: number }
    | { type: 'addMany'; items: Array<{ id: string; pos: number; side?: number }> }
    | { type: 'remove'; id: string }

export interface SliceSlot {
    offset: number
    file: string | File
}

export function isPlaceholderMeta(meta: unknown): meta is PlaceholderMeta {
    return meta !== null && typeof meta === 'object' && 'type' in meta
}
